import React from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'

export default class FixedHeader extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    paddingTop: PropTypes.number
  }

  static defaultProps = {
    paddingTop: 0
  }

  state = {}

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll)
  }

  @autobind
  onScroll() {
    const rect = this.header.getBoundingClientRect()
    if (this.state.fixed) {
      if (window.scrollY <= this.state.scrollY) {
        this.setUnfixed()
      }
    } else {
      if (rect.top - this.props.paddingTop <= 0) {
        this.setState({scrollY: window.scrollY})
        this.setFixed()
      }
    }
  }

  @autobind
  setFixed() {
    const height = this.header.clientHeight
    const width = this.header.clientWidth
    this.setState({height, width, fixed: true})
  }

  @autobind
  setUnfixed() {
    this.setState({height: 0, fixed: false})
  }

  getStyle() {
    if (!this.state.fixed) return
    return {
      position: 'fixed',
      top: this.props.paddingTop,
      height: this.state.height,
      width: this.state.width
    }
  }

  render() {
    return (
      <div className="fixed-container">
        <div
          ref={header => {
            this.header = header
          }}
          style={this.getStyle()}
        >
          {this.props.children}
        </div>
        <div style={{height: this.state.height, width: this.state.width}} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/FixedHeader/index.js